exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex-center[data-v-54bc49a2] {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.flex-column[data-v-54bc49a2] {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.title[data-v-54bc49a2] {\n  font-weight: 550;\n}\n.error-text[data-v-54bc49a2] {\n  margin-bottom: 0px;\n}\n.mb-3[data-v-54bc49a2] {\n  margin-bottom: 20px;\n}", ""]);

// exports
